import {CSP_NONCE, Inject, Injectable, Optional} from '@angular/core';

/**
 * Manages a nonce-bearing <style> element for CSS rules that replace
 * inline :root {} variable declarations (used by ThemeService).
 * Element-level inline styles are handled separately by installCspStyleInterceptor() in main.ts.
 */
@Injectable({providedIn: 'root'})
export class CspStyleManager {
  private styleEl!: HTMLStyleElement;
  private sheet!: CSSStyleSheet;
  private currentProps: Record<string, string> = {};
  private ready = false;

  constructor(@Optional() @Inject(CSP_NONCE) private nonce: string | null) {}

  private init(): void {
    if (this.ready) return;
    this.ready = true;
    this.styleEl = document.createElement('style');
    if (this.nonce) this.styleEl.setAttribute('nonce', this.nonce);
    document.head.appendChild(this.styleEl);
    this.sheet = this.styleEl.sheet as CSSStyleSheet;
  }

  setRootProperties(props: Record<string, string>): void {
    this.init();
    this.currentProps = {...props};
    this.render();
  }

  setRootProperty(key: string, value: string): void {
    this.init();
    this.currentProps[key] = value;
    this.render();
  }

  private render(): void {
    while (this.sheet.cssRules.length) this.sheet.deleteRule(0);
    const decl = Object.entries(this.currentProps).map(([k, v]) => `  ${k}: ${v};`).join('\n');
    if (decl) this.sheet.insertRule(`:root {\n${decl}\n}`, 0);
  }
}
